export const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);

export const floatClamp = (num: number, min: number, max: number) => Math.max(min, Math.min(max, num / 180));

export const mapRange = (numberA: number, minA: number, maxA: number, minB: number, maxB: number): number => {
  const normalizedValue = (numberA - minA) / (maxA - minA);
  const mappedValue = normalizedValue * (maxB - minB) + minB;
  return mappedValue;
};
